<template>
  <nav
    class="navbar navbar-expand-lg navbar-absolute"
    style="height: 100px"
    :class="{ 'bg-white': showMenu, 'navbar-transparent': !showMenu }"
  >
    <div class="container-fluid">
      <div class="navbar-wrapper">
        <div
          class="navbar-toggle d-inline"
          :class="{ toggled: $sidebar.showSidebar }"
        >
          <button
            type="button"
            class="navbar-toggler"
            aria-label="Navbar toggle button"
            @click="toggleSidebar"
          >
            <span class="navbar-toggler-bar bar1"></span>
            <span class="navbar-toggler-bar bar2"></span>
            <span class="navbar-toggler-bar bar3"></span>
          </button>
        </div>
        <h2 class="navbar-brand" href="">{{ routeName }}</h2>
      </div>
      
      <button
        v-if="isLoggedIn"
        class="btn btn-danger btn-sm ml-auto" 
        @click="logout"
        style="margin-right: 20px;"
      >
        <i class="tim-icons icon-button-power"></i> Logout
      </button>
    </div>
  </nav>
</template>
<script>
import { CollapseTransition } from "vue2-transitions";
import Modal from "@/components/Modal";
import axios from "@/services/axiosInstance";

export default {
  components: {
    CollapseTransition,
    Modal,
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    isRTL() {
      return this.$rtl.isRTL;
    },
    isLoggedIn() {
      return localStorage.getItem("isAuthenticated") === "true";
    }

  },
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: "",
    };
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    async logout() {
      try {
        await axios.post('/logout');
        localStorage.removeItem('user');
        localStorage.removeItem('isAuthenticated');
        this.$router.push({ name: 'Login' });
      } catch (error) {
        console.error('Logout error:', error);
        // Clear local storage and redirect anyway
        localStorage.removeItem('user');
        localStorage.removeItem('isAuthenticated');
        this.$router.push({ name: 'Login' });
      }
    }
  },
};
</script>
<style></style>
